import { render, staticRenderFns } from "./SelectCustomerReturnType.vue?vue&type=template&id=d2e8be1e"
import script from "./SelectCustomerReturnType.vue?vue&type=script&lang=js"
export * from "./SelectCustomerReturnType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports